export enum AcademyAdministratorType{
    HEADQUARTERS = 'Headquarters',
    SEASONS = 'Seasons',
    SCHS = "Schs",
    COURSES_LEVELS = 'CoursesAndLevels',
    GROUPS = 'ClassGroups',
    PRODUCTS_SERVICES = "ProductAndServices",
    AGREEMENTS_DISCOUNTS ="AgreementsAndDiscounts",
    INSTRUCTORS = 'Instructors',
    MEMBERS = 'members',
    MEMBERSHIPS = 'Memberships',
    CLUBES = 'clubes',
    COMPETITIONS = 'competitions',
    LEVELS = 'levels',
    CATEGORIES = 'categories',
    REGISTRATIONS = 'registrations',
    TELEMETRY = 'telemetry',
    MASSIVE_MEMBERS = 'MembersMassive',
    EXTERNAL_MEMBERS = 'externalMembers',
    COMPETITION_EVENTS = 'events',
}